import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Gauge } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ToolRunner } from "@/pages/AIStudio";
import { tierRank } from "@/lib/api";
import { findAts, loadTools, resetTools } from "@/lib/tools";

export const AtsPassButton = ({ job }) => {
  const navigate = useNavigate();
  const { tier } = useAuth();
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { resetTools(); loadTools().then(setData); }, [tier]);
  const tool = findAts(data?.tools);
  if (!data) return null;
  const locked = tool && tierRank(tool.tier) > tierRank(data.tier);
  const click = () => {
    if (!tool) navigate("/ai-studio");
    else if (locked) window.dispatchEvent(new CustomEvent("rpopro:upgrade", { detail: { tier: tool.tier, message: `${tool.title} needs ${tool.tier}` } }));
    else setOpen(true);
  };
  return (
    <>
      <Button variant="outline" onClick={click} className="rounded-full border-[#D4AF37]/50 text-[#F3C649] hover:bg-[#D4AF37]/10" data-testid="ats-pass-rate-button">
        <Gauge className="h-4 w-4" />ATS Pass Rate
      </Button>
      {open && <ToolRunner tool={tool} initialJob={{ id: job.id, title: job.title, company: job.company }} onClose={() => setOpen(false)} />}
    </>
  );
};
